import {
  IN_TIME_INSTALLED_SOFT,
  IS_SHOW_MENU_SPOT,
  SET_ABOUT_VISIBLE,
  SET_CAN_BACK,
  SET_CHECK_UPDATE_VISIBLE,
  SET_DETAIL_COMMENT_VISIBLE,
  SET_DOWNLOAD_PATH_VISIBLE,
  SET_DOWNLOAD_VISIBLE,
  SET_FIRST_RUN,
  SET_HOT_LENOVO_VISIBLE,
  SET_IFRAME_VISIBLE,
  SET_IS_ENABLED_SILENT,
  SET_MENU_ACTIVE,
  SET_NEW_VERSION_INFO,
  SET_OPERATION_MENU_VISIBLE,
  SET_PHONE_VISIBLE,
  SET_PINPOP_CLOSE_VISIBLE,
  SET_PINPOP_VISIBLE,
  SET_RELEASE_NOTES_VISIBLE,
  SET_SEARCH_KEYWORD,
  SET_TICK,
  SET_USER_FEEDBACK_VISIBLE,
  SET_TOP_IMG_VIDEO_VISIBLE,
  SET_SHARE_VISIBLE,
  SET_SHARE_LINK,
  SET_FASTER_PRODUCT,
  SET_MAXIMIZE,
  SET_MESSAGE_VISIBLE,
  SET_MESSAGE_ACTIVE_TAB,
} from '../constants/layout';

const initState = {
  activeMenu: '',
  searchKw: '',
  isTick: true,
  canback: false,
  firstRun: true,
  downloadVisible: false,
  OperationMenuVisible: false,
  AboutVisible: false,
  hotLenovoVisible: -1,
  pinPopVisible: false,
  pinPopCloseVisible: false,
  downloadPathVisible: false,
  phoneVisible: false,
  inTimeInstSoft: null,
  isShowMenuSpot: false,
  isEnabledSilent: false,
  iframeInfo: {},
  newVersionInfo: null,
  checkUpdateVisible: false,
  detailCommentInfo: {},
  releaseNotesVisible: false,
  userFeedbackVisible: false,
  topImgVideo: null,
  shareVisible: false,
  shareLink: {},
  fasterProduct: null, // 加速器
  isMaximize: false,
  messageVisible: false,
  messageActiveTab: 'comment', // 消息中心激活的tab
};

const layout = (state = initState, action = {}) => {
  switch (action.type) {
    case SET_MENU_ACTIVE:
      return { ...state, activeMenu: action.pathname };
    case SET_SEARCH_KEYWORD:
      return { ...state, searchKw: action.keyword };
    case SET_DOWNLOAD_VISIBLE:
      return { ...state, downloadVisible: action.visible };
    case SET_ABOUT_VISIBLE:
      return { ...state, AboutVisible: action.visible };
    // 独立包-检查更新
    case SET_CHECK_UPDATE_VISIBLE:
      return { ...state, checkUpdateVisible: action.visible };
    // 新版本-信息
    case SET_NEW_VERSION_INFO:
      return { ...state, newVersionInfo: action.newVersionInfo };
    case SET_OPERATION_MENU_VISIBLE:
      return { ...state, OperationMenuVisible: action.visible };
    case SET_TICK:
      return { ...state, isTick: action.visible };
    case SET_HOT_LENOVO_VISIBLE:
      return { ...state, hotLenovoVisible: action.visible };
    case SET_PINPOP_VISIBLE:
      return { ...state, pinPopVisible: action.visible };
    case SET_PINPOP_CLOSE_VISIBLE:
      return { ...state, pinPopCloseVisible: action.visible };
    case SET_DOWNLOAD_PATH_VISIBLE:
      return { ...state, downloadPathVisible: action.visible };
    case SET_CAN_BACK:
      return { ...state, canback: action.canback };
    case SET_FIRST_RUN:
      return { ...state, firstRun: action.firstRun };
    case SET_PHONE_VISIBLE:
      return { ...state, phoneVisible: action.visible };
    case IN_TIME_INSTALLED_SOFT:
      // 用于判断展示时长
      window.inTimeInstSoftTime =
        action.inTimeInstSoft && action.inTimeInstSoft.time ? action.inTimeInstSoft.time : 0;
      return { ...state, inTimeInstSoft: action.inTimeInstSoft };
    case IS_SHOW_MENU_SPOT:
      // 用于判断展示菜单上小红点
      return { ...state, isShowMenuSpot: action.isShowMenuSpot };
    case SET_IS_ENABLED_SILENT:
      // 用户判断是否打开快装
      return { ...state, isEnabledSilent: action.isEnabledSilent };
    case SET_IFRAME_VISIBLE:
      return { ...state, iframeInfo: action.param };
    case SET_DETAIL_COMMENT_VISIBLE:
      return { ...state, detailCommentInfo: action.param };
    case SET_RELEASE_NOTES_VISIBLE:
      return { ...state, releaseNotesVisible: action.visible };
    case SET_USER_FEEDBACK_VISIBLE: // 是否展示用户反馈界面
      return { ...state, userFeedbackVisible: action.visible };
    case SET_TOP_IMG_VIDEO_VISIBLE: // 是否展示头部图片或者视频
      return { ...state, topImgVideo: { ...state.topImgVideo, ...action.param } };
    case SET_SHARE_VISIBLE: // 分享弹窗
      return { ...state, shareVisible: action.visible };
    case SET_SHARE_LINK: // 分享弹窗链接
      return { ...state, shareLink: action.link };
    case SET_FASTER_PRODUCT: // 加速器弹窗
      return {
        ...state,
        fasterProduct: action.payload,
      };
    case SET_MAXIMIZE:
      return { ...state, isMaximize: action.payload.isMaximize };

    case SET_MESSAGE_VISIBLE: // 消息盒子弹窗
      return { ...state, messageVisible: action.visible };
    case SET_MESSAGE_ACTIVE_TAB: // 消息盒子弹窗
      return { ...state, messageActiveTab: action.payload };
    default:
      return state;
  }
};

export default layout;
